import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-admin";
import { 
  Announcement, 
  People, 
  Map, 
  WatchLater,
  ArrowBack 
} from "@material-ui/icons";

// Componente de navegación para tours
export const TourNavigation = ({ currentPage, tourId, onBack }) => {
  const navigationItems = [
    {
      to: "/tours _due",
      label: "Tours Due",
      icon: <Announcement />,
      active: currentPage === "tour_due_list"
    },
    {
      to: "/tour_clients",
      label: "Tour Clients",
      icon: <People />,
      active: currentPage === "tour_clients"
    },
    {
      to: "/tours",
      label: "Tours Whiteboard",
      icon: <Map />,
      active: currentPage === "tours"
    },
    {
      to: "/tour_management",
      label: "Pending Tours",
      icon: <WatchLater />,
      active: currentPage === "tour_management"
    }
  ];

  return (
    <div style={{ 
      display: "flex", 
      gap: "10px", 
      marginBottom: "20px",
      padding: "10px",
      backgroundColor: "#f5f5f5",
      borderRadius: "5px"
    }}>
      {onBack && (
        <Button
          component={Link}
          to={onBack}
          label="Volver"
          startIcon={<ArrowBack />}
          style={{ marginRight: "10px" }}
        />
      )}
      
      {navigationItems.map((item) => (
        <Button
          key={item.to}
          component={Link}
          to={item.to}
          label={item.label}
          startIcon={item.icon}
          style={{
            backgroundColor: item.active ? "#1976d2" : "transparent",
            color: item.active ? "white" : "inherit"
          }}
        />
      ))}
    </div>
  );
};

// Componente de breadcrumb para tours
export const TourBreadcrumb = ({ items }) => (
  <div style={{ 
    display: "flex", 
    alignItems: "center", 
    gap: "10px",
    marginBottom: "15px",
    fontSize: "14px"
  }}>
    {items.map((item, index) => (
      <React.Fragment key={item.to || index}>
        {item.to ? (
          <Link 
            to={item.to}
            style={{ 
              color: "#1976d2", 
              textDecoration: "none",
              fontWeight: index === items.length - 1 ? "bold" : "normal"
            }}
          >
            {item.label}
          </Link>
        ) : (
          <span style={{ color: "#666" }}>{item.label}</span>
        )}
        {index < items.length - 1 && (
          <span style={{ color: "#ccc" }}>/</span>
        )}
      </React.Fragment>
    ))}
  </div>
);

// Componente de enlaces rápidos
export const QuickTourLinks = ({ tourId }) => (
  <div style={{ 
    display: "flex", 
    gap: "5px",
    marginBottom: "10px"
  }}>
    <Button
      component={Link}
      to={`/tour_clients/${tourId}/show`}
      label="Detalles"
      size="small"
    />
    <Button
      component={Link}
      to={`/process_tour_enhanced/${tourId}`}
      label="Editar"
      size="small"
    />
    <Button
      component={Link}
      to="/tour_due_list"
      label="Lista"
      size="small"
    />
  </div>
); 


// WEBPACK FOOTER //
// ./src/components/TourNavigation.js